// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container_24bmc","loader":"Page_loader_15LOi","content":"Page_content_vkpZr","notAvailable":"Page_notAvailable_fFXxG"};